<template>
    <nav class="floating_menu" data-step="4" :class="(add_fast) ? 'open_fast' : ''">
        <input type="checkbox" href="#" class="menu-open" name="menu-open" id="menu-open" v-model="add_fast" />
        <label class="menu-open-button fa fa-pencil" for="menu-open"></label>
        <router-link :to="{ name: 'sent-emails.create' }" v-pml-tooltip.top="$t('email')" class="menu-item bg_green_1"><i class="fa fa-envelope-o"></i></router-link>
        <router-link :to="{ name: 'calendar.create' }" v-pml-tooltip.top="$t('task')" class="menu-item bg_green_2"><i class="fa fa-tasks"></i></router-link>
        <router-link :to="{ name: 'follow-ups.create' }" v-pml-tooltip.top="$t('follow_up')" class="menu-item bg_green_3"><i class="fa fa-history"></i></router-link>
        <router-link :to="{ name: 'deals.create' }" v-pml-tooltip.top="$t('deal')" class="menu-item bg_green_4"><i class="fa fa-user-plus"></i></router-link>
    </nav>
</template>

<script>
    export default {
        name: 'FloatingMenu',
        data () {
            return {
                add_fast: false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/root/FloatingMenu.vue